import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import serviceEndpoints from '../../../../config/serviceEndpoints';
import staticGateway from '../../../../config/service';

export const logoutUser = createAction('logout');

export const loginUser = createAsyncThunk('auth/login', async (data, { rejectWithValue }) => {
    const body = { ...data, platform: 'web' };
    try {
        const response = await staticGateway.post(serviceEndpoints.login, body);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }

        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

const slice = createSlice({
    name: 'auth',
    initialState: {
        resMsg: '',
        userId: null,
        role_id: null,
        isLoading: false,
        isLoggedIn: false,
        loginfail: false,
        userData: localStorage.getItem('userDetails') || {},
    },

    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.isLoading = true;
                state.isLoggedIn = false;
                state.resMsg = '';
                state.userData = {};
                state.loginfail = false;
            })
            .addCase(loginUser.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.isLoggedIn = false;
                state.resMsg = payload;
                state.userData = {};
                state.loginfail = true;
            })
            .addCase(loginUser.fulfilled, (state, { payload }) => {
                const { user, token, success, message } = payload;
                state.isLoading = false;
                state.userId = user?.id;
                state.role_id = user?.role_id;
                state.resMsg = message;
                state.userData = user;
                state.loginfail = false;

                if (success === true && !localStorage.getItem('rememberMe')) {
                    state.isLoggedIn = true;
                    sessionStorage.setItem('access_token', token?.accessToken);
                    sessionStorage.setItem('userDetails', JSON.stringify(user));
                }
                if (success === true && localStorage.getItem('rememberMe')) {
                    state.isLoggedIn = true;
                    localStorage.setItem('access_token', token?.accessToken);
                    localStorage.setItem('userDetails', JSON.stringify(user));
                }
            })
            .addCase('logout', (state) => {
                state.isLoading = false;
                state.isLoggedIn = false;
                state.resMsg = '';
                state.userData = {};
                state.loginfail = false;
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/';
            });
    },
});

export default slice.reducer;
